import React, { Component,useEffect,useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable,{defaultThemes} from 'react-data-table-component';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HTMLParserComponent from "../HTMLParserComponent.js"

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import '../preloading.css';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";



import Select from 'react-select';




import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const Attendance = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;

	// function getDate() {
	// 	const today = new Date();
	// 	const month = today.getMonth() + 1;
	// 	const year = today.getFullYear();
	// 	const date = today.getDate();
	// 	return `${year}-${month}-${date}`;
	//   }

	const today = new Date().toISOString().split("T")[0];


	const [user, setUser] = useState({
        start_date: today,
        department:"",
    })



	

	
	const history = useHistory();
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
	const [attnlist, setattnlist]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);

	const { sortConfig, sortData, handleSort } = useSortData();


    const handelInput = (event) => {
        // event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

    
    }


	const handleDepartmentSelect = (selected) => {
    setUser(prev => ({
        ...prev,
        department: selected ? selected.value : ""
    }));
};

    const [shiftcode,setShiftCodeValue]= useState("");
	const [officeshift,setOfficeShift]= useState([]);

	const handleShift = (event) => {
	const value = event.target.value;
	setShiftCodeValue(value);

	
  };


  const allOptions = [
  { value: "", label: "All Department" },
  ...dataval.map(option => ({
    value: String(option.department_id),
    label: option.department_name
  }))
];


		const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [entriesPerPage,setEntriesPerPage]=useState(10);
		
		let filteredItems = records.filter((item) =>
			`${item.employee_id.toLowerCase()}${item.employee_name.toLowerCase()}${item.department_name.toLowerCase()}$${item.shift_info.toLowerCase()}${item.status.toLowerCase()}${item.tdate.toLowerCase()}`.includes(searchTerm.toLowerCase())
		 
		);
		const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
		const indexOfLast = currentPage * entriesPerPage;
		const indexOfFirst = indexOfLast - entriesPerPage;
		// const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

		const sortedItems = sortData(filteredItems);
const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);

	  
		
	
	  const handleSearch = (event) => {
		//console.log(event.target.value);
		 setSearchTerm(event.target.value);
	  };
	

	  const clearInput = () => {
		setSearchTerm("");
	  };
	 





      const handleDepartment = async () => {
	  
        axios.get(API_BASE_URL +'/showdepartment/', { headers : {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${localStorage.getItem("authToken")}`
       }})
        .then(res1 => setdataval(res1.data))
        .catch(err => console.log(err))
       };
  
  
       useEffect(() => {
        handleDepartment();
      }, []);



	  const handleShiftCode = async () => {

	axios.get(API_BASE_URL + '/read_shift_info', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})
//    .then(res1 => console.log(res1.data))
	.then(res1 => setOfficeShift(res1.data))
	.catch(err => console.log(err))
   };

    useEffect(() => {
	handleShiftCode();
	 }, []);




const handleSubmit = async (e) => {
    e.preventDefault();
	setLoading(true);

	// alert(user.start_date);
    // alert(user.department);

	
    try {
      const response = await axios.post(API_BASE_URL +'/attendancelist',
		{ attendance_date: user.start_date, dept_id: user.department }, 
		{
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}

);
// console.log(response.data.shiftattendance);
      setRecords(response.data.shiftattendance); // Assuming the API response contains the records in `response.data`
	  setLoading(false);
	} catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(()=> {
	axios.post(API_BASE_URL +'/attendancelist',{ attendance_date: user.start_date, dept_id: user.department }, {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

    // .then(response =>console.log(response.data.shiftattendance))
	 .then(response => setRecords(response.data.shiftattendance))
	.catch(err => console.log(err));
},[])




	const handleUpdateApprovePermission = async (user_id,shift_date,attn_history) => {

			// console.log('hi');

			// alert(user_id);
			// alert(shift_date);

			// e.preventDefault();

			// console.log(user);
			// setError(null);
			// setLoading(true);
			// e.preventDefault();
			//console.log(user);

				axios.post(API_BASE_URL + '/update_approve_permission', { user_id: user_id, shift_date: shift_date,attn_history: attn_history}, {

			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
			}).then(response => {

				


			var status = response.data.status;

			if (status=='success')
			{
			toast.success(response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});
			const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} 
			else if (status=='error')
			{
			toast.error(response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});
			

			}
			}).catch(error => {

			// console.log(error);
			// console.log(error.response.data.message);
			toast.error(error.response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});

			});
			};




			const handleUpdateRejectPermission = async (user_id,shift_date,attn_history) => {

			// console.log('hi');

			// alert(user_id);
			// alert(shift_date);

			// e.preventDefault();

			// console.log(user);
			// setError(null);
			// setLoading(true);
			// e.preventDefault();
			//console.log(user);

				axios.post(API_BASE_URL + '/update_reject_permission', { user_id: user_id, shift_date: shift_date,attn_history: attn_history}, {

			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
			}).then(response => {

				


			var status = response.data.status;

			if (status=='success')
			{
			toast.success(response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});
			const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} 
			else if (status=='error')
			{
			toast.error(response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});
			

			}
			}).catch(error => {

			// console.log(error);
			// console.log(error.response.data.message);
			toast.error(error.response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});

			});
			};


	const emptyUser={
	shift_code: '',
    attendance_date: '',
    clock_in_date: '',
    clock_in: '',
    clock_out_date: '',
	clock_out: '',
	employee_id:'',
	user_id:'',
	old_clock_in_date: '',
	old_clock_in: '',
	old_clock_out_date: '',
	old_clock_out: '',
	old_shift_code: '',
	attendance_history:'',
	}



const [modalData, setModalData] = useState({
	search_dept_id:'',
	shift_date:'',
    shift_code: '',
    attendance_date: '',
    clock_in_date: '',
    clock_in: '',
    clock_out_date: '',
	clock_out: '',
	employee_id:'',
	user_id:'',
	old_clock_in_date: '',
	old_clock_in: '',
	old_clock_out_date: '',
	old_clock_out: '',
	old_shift_code: '',
	attendance_history:'',
});

const handelModalInput = (e) => {
    const { name, value } = e.target;
    setModalData({ ...modalData, [name]: value });
};

	const handleUpdate = async (user_id,attn_date,dept_id) => {

		//  console.log(user_id);
		// console.log(attn_date);
		const search_emp_id=0;

		axios.get(API_BASE_URL + '/read_shift_data/' + user_id +'/'+attn_date+'/'+dept_id+'/'+search_emp_id, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		   
			.then(res => {
     console.log(res.data.readshift);  // data is here
    setModalData(res.data.readshift); // set modal fields
    setattnlist(res.data.readshift.attn_list); // set attendance list
  })
			.catch(err => console.log(err))
	};



	const handleEditSubmit = (e) => {

		e.preventDefault();

		// alert(modalData.search_dept_id);
		// console.log(user);
		// setError(null); 
		// setLoading(true);
		// e.preventDefault();
		axios.post(API_BASE_URL + '/update_shift_and_attendance', {shift_date : modalData.attendance_date, shift_code: modalData.shift_code, clock_in_date: modalData.clock_in_date,clock_in: modalData.clock_in,clock_out_date: modalData.clock_out_date,clock_out : modalData.clock_out, employee_id: modalData.employee_id,user_id: modalData.user_id,old_clock_in_date: modalData.old_clock_in_date,old_clock_in: modalData.old_clock_in,old_clock_out_date: modalData.old_clock_out_date,
	old_clock_out: modalData.old_clock_out,
	old_shift_code: modalData.old_shift_code,attn_history: modalData.attendance_history }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response.data);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 'success') {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});



				


				// Reset date to today
    // setUser(prev => ({
    //     ...prev,
    //     start_date: today
    // }));


	window.$("#attendanceModal").modal("hide");

    // Reload attendance based on updated date
    reloadAttendance(modalData.shift_date,modalData.search_dept_id);


	// const timeout = setTimeout(() => {
	// 				window.location.reload(); // Reload the current page
	// 			}, 5000); // Refresh after 5 seconds

	// 			return () => {
	// 				clearTimeout(timeout); // Cleanup the timeout if the component unmounts
	// 			};


			} else if (status == 'error') {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 'error') {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}

			else if (status == '401') {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);


			if (error.response) {
          // Show message only in console
          toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});
      } else {
          console.error('Request failed:', error);
      }

			

		});
	};


	
const reloadAttendance = (searchdate,searchdept) => {
  axios.post(API_BASE_URL + '/attendancelist',
    { attendance_date: searchdate, dept_id: searchdept },
    { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
  )
  .then(res => setRecords(res.data.shiftattendance));
};



const columns = [
  { label: "Emp Id", key: "employee_id", sortable: true },
  { label: "Employee Name", key: "employee_name", sortable: true },
  { label: "Department", key: "department_name", sortable: true },
  { label: "Shift", key: "shift_info", sortable: true },
  { label: "Status", key: "status", sortable: true },
  { label: "Date", key: "tdate", sortable: true },
  { label: "In", key: "punch_in", sortable: true },
  { label: "Out", key: "punch_out", sortable: true },
  { label: "Work", key: "total_work", sortable: true },
  { label: "Overtime", key: "extra_overtime", sortable: true }
];


const formatDate = (date) => {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};




	return (
		<>
			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

						<ToastContainer/>
							

						</div>


						
					</div>



							<div className="section-body mb-4">
							<Link to={`/attendance`}>
							<button className="btn btn-primary me-2" >
							 Regular Employee
							</button>
							</Link>
					
							<Link to={`/attendance-contractor`}>
							<button className="btn btn-light me-2" >
							  Contractor Employee
							</button>
							  </Link>
					
							
						  </div>


                    <div className="section-body mt-3">
					<div className="container-fluid">
						<div className="row clearfix">
							<div className="col-md-12">
								<div className="card">
									{/* <div className="card-header">
										<h3 className="card-title">My Shift</h3>
									</div> */}
									<div className="card-body">
										 <form onSubmit={handleSubmit}> 

                                            <div class="row">

											<div className="col-md-2 col-sm-6">
												<div className="form-group">
												{/* <input type="date" className="form-control" name="start_date" value={user.start_date}
								onChange={handelInput} placeholder="Start Date" /> */}

								<DatePicker
								  selected={user.start_date ? new Date(user.start_date) : null}
								  onChange={(date) => {
									const value = date
									  ? date.toISOString().split("T")[0] // YYYY-MM-DD
									  : "";
								
									setUser(prev => ({
									  ...prev,
									  start_date: value,
									}));
								  }}
								  dateFormat="dd-MM-yyyy"
								  placeholderText="Select Start Date"
								  className="form-control"
								   showMonthDropdown
									showYearDropdown
									dropdownMode="select"
								/>
											
												</div>
											</div>

										
									{/* <div className="col-md-4 col-sm-6">
													<label>
									Select Department Head <span style={{ color: "red" }}>*</span>
								</label>
											<Select
									defaultValue={user.department}
									// name="dept_head"
									onChange={handelInput} placeholder='Select Department Head'
									options={dataval}
								/>
								</div> */}
                                

                                    <div className="col-md-4 col-sm-6">
									<Select
    name="department"
    value={
        user.department
            ? allOptions.find(opt => opt.value === user.department)
            : null
    }
    onChange={handleDepartmentSelect}
    options={allOptions}
    isSearchable={true}
    placeholder="All Department"
	  styles={{
  control: (base) => ({
    ...base,
    minHeight: "28px",
    height: "28px",
    borderRadius: "4px",
    borderColor: "#ced4da",
    boxShadow: "none",
    fontSize: "12px",
    padding: "0 4px",
    "&:hover": { borderColor: "#b3b3b3" }
  }),

  valueContainer: (base) => ({
    ...base,
    height: "28px",
    padding: "0 6px",
  }),

  input: (base) => ({
    ...base,
    margin: "0px",
    padding: "0px"
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: "28px"
  }),

  menu: (base) => ({
    ...base,
    borderRadius: "4px",
    zIndex: 9999
  }),

  option: (base, state) => ({
    ...base,
    fontSize: "12px",
    padding: "6px 10px",
    backgroundColor: state.isFocused ? "#f8f9fa" : "white",
    color: "#333"
  })
}}
classNamePrefix="react-select"
/>

                                    </div>
                                    
							

								
								


                                <div className="col-md-4 col-sm-6">
									<div className="form-group">

                                <button type="submit" className="btn btn-primary">
								GET
							</button>

							

							
                            </div>
                            </div>



                            </div>

                            
                               

                                           


										
	
										
											
										 </form>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>




<div className="modal fade" id="attendanceModal" tabIndex="-1" role="dialog" aria-hidden="true">




  <form onSubmit={handleEditSubmit}>
    <div className="modal-dialog" role="document">
      <div className="modal-content" style={{ width: '650px'}}>
        <div className="modal-header">
          <h5 className="modal-title">Edit Attendance for {modalData.full_name}</h5>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div className="modal-body">
          <div className="row clearfix">
            <div className="col-md-6">
              <div className="form-group">
               
										<label className="form-label">Shift Code<span className="form-required">*</span></label>
										<select className="form-control show-tick" name="shift_code" value={modalData.shift_code} onChange={handelModalInput} >
										<option value="">Select Shift Code</option>
											{officeshift.map(option => (
											<option key={option.shift_code} value={option.shift_code}>
											{option.shift_name}
											</option>
											))}
									</select>
									
									</div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="form-label">Shift Date</label>
                {/* <input type="date" className="form-control" name="attendance_date" value={modalData.attendance_date} onChange={handelModalInput} /> */}
                    <DatePicker
								  selected={modalData.attendance_date ? new Date(modalData.attendance_date) : null}
								  onChange={(date) => {
									const value = date
									  ? date.toISOString().split("T")[0] // YYYY-MM-DD
									  : "";
								
									setModalData(prev => ({
									  ...prev,
									  attendance_date: value,
									}));
								  }}
								  dateFormat="dd-MM-yyyy"
								  placeholderText="Select Attendance Date"
								  className="form-control"
								  showMonthDropdown
								  showYearDropdown
								  dropdownMode="select"
								/>
			  </div>
            </div>
           

			 <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Clock In Date<span className="form-required">*</span></label>
                {/* <input type="date" className="form-control" name="clock_in_date" value={modalData.clock_in_date} onChange={handelModalInput} /> */}
				 <DatePicker
								  selected={modalData.clock_in_date ? new Date(modalData.clock_in_date) : null}
								  onChange={(date) => {
									const value = formatDate(date);
								
									setModalData(prev => ({
									  ...prev,
									  clock_in_date: value,
									}));
								  }}
								  dateFormat="dd-MM-yyyy"
								  placeholderText="Select ClockIn Date"
								  className="form-control"
								  showMonthDropdown
								  showYearDropdown
								  dropdownMode="select"
								/>
			  </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label className="form-label">In Time<span className="form-required">*</span></label>
                <input type="time" className="form-control" name="clock_in" value={modalData.clock_in} onChange={handelModalInput} />
              </div>
            </div>

			 <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Clock Out Date<span className="form-required">*</span></label>
                {/* <input type="date" className="form-control" name="clock_out_date" value={modalData.clock_out_date} onChange={handelModalInput} /> */}
				<DatePicker
								  selected={modalData.clock_out_date ? new Date(modalData.clock_out_date) : null}
								  onChange={(date) => {
									const value = formatDate(date);
								
									setModalData(prev => ({
									  ...prev,
									  clock_out_date: value,
									}));
								  }}
								  dateFormat="dd-MM-yyyy"
								  placeholderText="Select ClockOut Date"
								  className="form-control"
								  showMonthDropdown
								  showYearDropdown
								  dropdownMode="select"
								/>
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label className="form-label">Out Time<span className="form-required">*</span></label>
                <input type="time" className="form-control" name="clock_out" value={modalData.clock_out} onChange={handelModalInput} />
              </div>
            </div>



			<div class="col-md-12">
            <div class="form-group">
             

                <textarea cols="50" rows="5" name="attendance_history" value={modalData.attendance_history} hidden/>
                
				<input  name="shift_date" type="hidden" value={modalData.shift_date} />
				<input  name="search_dept_id" type="hidden" value={modalData.search_dept_id} />
				
				<input name="old_clock_in_date" type="hidden" value={modalData.clock_in_date} />

                  <input  name="old_clock_in" type="hidden" value={modalData.clock_in} />

                   <input  name="old_clock_out_date" type="hidden" value={modalData.clock_out_date} />

                <input name="old_clock_out" type="hidden" value={modalData.clock_out} />

                <input name="old_shift_code" type="hidden" value={modalData.shift_code} />


				<input name="employee_id" type="hidden" value={modalData.employee_id} />
				<input name="user_id" type="hidden" value={modalData.user_id} />
            
            </div>
          </div>
           
          </div>
        </div>


		 <div class="row">

			<div class="col-md-12">
        
			<div className="table-responsive">
		
			<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>
                                                            {/* <th style={{backgroundColor:'rgba(204, 31, 0, 1)',color:'#fff'}}>Clock in</th>
                                                            <th style={{backgroundColor:'#08c',color:'#fff'}}>Clock Out</th> */}
                                                           
														</tr>
													</thead>
													<tbody>
													{attnlist.length > 0 ? (
															attnlist.map((attnlst) => {

																

																return(
															<tr key={attnlst.time_attendance_id}>

																	<td>{attnlst.clock_in}</td>
																	<td>{attnlst.clock_out}</td>

															</tr>


														)
														})
														) : (
															<tr>
															<td colSpan="7" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
															</tr>
														)}

													</tbody>
													</table>

													</div>

		 </div>
		 </div>


	


		


		
    
  



        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="submit" className="btn btn-primary">Update</button>
        </div>

		




      </div>
    </div>
  </form>
</div>




					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">

										<div className="card-header">
											<h3 className="card-title" style={{color:'#e96827'}}>Daily Attendance Report</h3>
											<div
  className="card-options"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>
  <EntriesSelector
    entriesPerPage={entriesPerPage}
    setEntriesPerPage={setEntriesPerPage}
    setCurrentPage={setCurrentPage}
  />

  {/* 🔽 SEARCH BOX WRAPPER */}
  <div style={{ position: "relative", width: "200px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "100%",
        height: "30px",
        fontSize: "13px",
        borderRadius: "4px",
        paddingRight: "28px", // ✅ space for X
      }}
    />

    {searchTerm.length > 0 && (
      <span
        onClick={clearInput}
        style={{
          position: "absolute",
          right: "8px",        // ✅ INSIDE input
          top: "50%",          // ✅ vertically centered
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#aaa",
          fontSize: "16px",
          userSelect: "none",
        }}
      >
        ✖
      </span>
    )}
  </div>
</div>

										</div>


{loading && (
											<div className="card-body">
											<div class="d-flex justify-content-center">
       <div class="spinner"></div>
	   </div>
	   </div>
      )}

{!loading && (
										<div className="card-body">
										
											<div className="table-responsive">
		

    
      
			<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
  <tr>
    <th></th>
    <th>Apply Leave</th>
    <th>Permission</th>

    {columns.map((col) => (
      <th
        key={col.key}
        onClick={col.sortable ? () => handleSort(col.key) : null}
        style={{ cursor: col.sortable ? "pointer" : "default" }}
      >
        {col.label}
        {col.sortable && (
      sortConfig.key === col.key
        ? (sortConfig.direction === "asc" ? " ▲" : " ▼")
        : " ⇅"   // <-- DEFAULT SORT ICON
    )}
      </th>
    ))}
  </tr>
</thead>

													<tbody>
														{/* {console.log(records)} */}
													{records.length > 0 ? (
															filteredData.map((record) => {

															let permission;

															if(record.permission_method=='NotGranted')
															{
																permission =  <button className="btn btn-primary" onClick={() => handleUpdateApprovePermission(record.user_id,record.tdate,record.attn_history)}>Not Granted</button>;
															}
															else if(record.permission_method=='Granted')
															{
																permission = <button className='btn' style={{ backgroundColor:'#17a2b8'}} onClick={() => handleUpdateRejectPermission(record.user_id,record.tdate,record.attn_history)}>Granted</button>;
															}

															return(
															<tr key={record.employee_id}>
																<td>

																	{/* <button
																			type="button" onClick={() =>{ handleUpdate(record.user_id,record.attn_date);setUser(emptyUser)}}
																			className="btn btn-icon btn-sm"
																			title="Edit" data-toggle="modal"
																			data-target="#exampleEditModal"
																		></button> */}

																	<button
																		type="button" onClick={() =>{ setModalData(emptyUser);handleUpdate(record.user_id,record.attn_date,record.department_id)}}
																		className="btn btn-primary"
																		data-toggle="modal"
																		data-target="#attendanceModal"
																		>
																	<i className="fa fa-edit" />
																	</button>
																	
																</td>

																

																<td>
																	<Link to={`/attendanceleave?id=${record.user_id}&attn_date=${record.attn_date}`}>
																	<i className="fe fe-maximize" />
																	</Link>
																</td>
																<td>{permission}</td>
																<td>{record.employee_id}</td>
																<td>{record.employee_name}<br/><span style={{ fontWeight: '600' }}>
																		{ReactHtmlParser(record.reg)}
																	</span></td>
																<td>{record.department_name}</td>
																<td>{ReactHtmlParser(record.shift_info)}</td>
																<td>{ReactHtmlParser(record.status)}</td>
																<td>{record.tdate}</td>
																<td>{ReactHtmlParser(record.punch_in)}</td>
																<td>{ReactHtmlParser(record.punch_out)}</td>
																<td>{record.total_work}</td>
																<td>{record.extra_overtime}</td>

															</tr>
															)
})
														) : (
															<tr>
															<td colSpan="7" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
															</tr>
														)}

											
													</tbody>
												</table>
											</div>
										
			  <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
								

										</div> 
)
}
									</div>
								</div>
	
							
							</div>
						</div>
					</div>

				</div>
			</div> 

										
			


			
			


			

		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(Attendance);